import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Home from "./pages/Home"
import Menu from "./pages/Menu"
import Product from "./pages/Product"
import Cart from "./pages/Cart"
import Admin from "./pages/Admin"
import Receipt from "./pages/Receipt" // Import the new Receipt component
import { CartProvider } from "./CartContent"

function App() {
  return (
    <Router>
      <CartProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/product" element={<Product />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/receipt" element={<Receipt />} />
        </Routes>
      </CartProvider>
    </Router>
  )
}

export default App
